import AdminHeader from "../common/AdminHeader";

const AdminDashboard = () => {
  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <div>{localStorage.getItem("Role") === "SUPERADMIN" ? "Super Admin Dashboard" : "Admin Dashboard" }</div>
      </div>
    </>
  );
}

export default AdminDashboard;
